







































































































































import { Component, Vue } from "vue-property-decorator";
import { GeneralService } from "../services/general-service";
import ProgramLevel from "../components/ProgramLevel.vue";
import config from "../services/api-config";
import router from "../router";
import AuthService from "../services/auth-service";

@Component({
  components: {
    "program-level": ProgramLevel,
  },
})
export default class SubjectSelect extends Vue {
  private service = new GeneralService();
  public entities: UserProramsModel[] = [];
  private boards: any = [];
  private activated: boolean = false;
  private boardSelected = false;
  private boardName = "";
  private level_id;
  private fullAccess = false;
  private auth = new AuthService();
  private boardUserSelected = false;
  private parts:any = [];
  private isPart2:boolean = false;
  public valuename: any = {};
  public storedInfo: any = [];
  public studentData: any = [];

  goToTest() {
    this.$router.push("testclassselect");
  }

  getImgUrl(pet) {
    if (pet[pet.length - 1] == " ") {
      pet = pet.substring(0, pet.length - 1);
    }
    const images = require.context("@/assets/images/icons/", false, /\.png$/);
    try {
      return images("./" + pet + ".png");
    } catch {
      // return images('./error.png')
    }
  }

  getImgUrl2(pet) {
    if (pet[pet.length - 1] == " ") {
      pet = pet.substring(0, pet.length - 1);
    }
    const images = require.context("@/assets/images/icons/", false, /\.svg$/);
    try {
      return images("./" + pet + ".svg");
    } catch {
      // return images('./error.png')
    }
  }

  private selectBoard(id, name) {
    this.entities = [];
    this.boardName = name;
    this.activated = false;
    if (this.fullAccess) {
      this.boardSelected = true;
      this.service.getBoardPrograms(id).then((result) => {
        this.entities = result;
        this.activated = true;
      });
    } else {
      this.service
        .getBoardProgramsEx(this.auth.session.varification)
        .then((result) => {
          let program = result.find((element) => element.board == name);
          this.service
            .classlevel(program.bupId)
            .then((result2) => {
              if (this.isPart2){
                localStorage[config.studentPartInfo] = JSON.stringify(result2);
                this.navigateTo(result2[1]);
              }
              else {
                localStorage[config.studentPartInfo] = JSON.stringify([result2[0]]);
                this.navigateTo(result2[0]);
              }
            })
            .catch((err) => {
              console.error(`Error: ${err.message}`);
            });
        });
    }
  }

  private navigateTo(entity) {
    localStorage[config.classLevl] = entity.clId;
    localStorage[config.programSelect] = JSON.stringify({
      val: entity.clId,
      user: this.auth.session.userId,
      part: entity.fullName,
      name: this.auth.session.varification,
      board: this.boardName,
    });
    if (this.$route.query.type && this.$route.query.type == "cms") {
      router.push("selectCMS");
    } else {
      router.push("selectEL");
    }
  }

  mounted() {
    if (
      !isNaN(parseInt(this.auth.session.varification)) ||
      this.auth.session.varification == "-1"
    ) {
      this.fullAccess = true;
    }

    let username = this.auth.session.userName.split("@")[0];

    this.service.getAllBoards().then((result) => {
      this.service.getInfoEMS(username).then((userdata) => {
        for (let i = 0; i < userdata.data.length; i++){
          if (userdata.data[i].Class.indexOf('II') > -1)
            this.isPart2 = true;
        }

        this.studentData = userdata.data;
        this.storedInfo = localStorage.getItem(config.studentPartInfo);
        if (this.storedInfo) {
          let storedArr = typeof this.storedInfo === 'string' ? JSON.parse(this.storedInfo) : this.storedInfo;
          let level = JSON.parse(localStorage[config.programSelect] || 'null');
          if (level && storedArr) {
            let currentPart = storedArr.find(p => p.fullName === level.part);
            this.valuename = currentPart ? this.studentData.find(e => e.Class === currentPart.fullName) : {};
          }
        }

        this.boards = result;
      });
    });
  }
}
